import MobileStoreButton, { EStoreName } from '@r1-frontend/ui-react/components/buttons/mobileStoreButton';

import { Container } from './styled';

interface IProps {
    className?: string,
    position?: 'up' | 'down',
}

const MobileStores = ({ className, position }: IProps): JSX.Element => {
    const storesLinks = {
        appStore: `https://apps.apple.com/app/apple-store/id799358248?pt=1497844&ct=${position}_banner&mt=8`,
        googlePlay: `https://play.google.com/store/apps/details?id=com.ertelecom.agent&hl=ru&referrer=utm_source%3Dsite_page%26utm_content%3D${position}banner`,
    };

    return (
        <Container className={className}>
            <MobileStoreButton
                store={EStoreName.AppStore}
                link={storesLinks.appStore}
                data-test='store-btn'
            />
            <MobileStoreButton
                store={EStoreName.GooglePlay}
                link={storesLinks.googlePlay}
                data-test='store-btn'
            />
            <MobileStoreButton
                store={EStoreName.AppGallery}
                data-test='store-btn'
            />
            <MobileStoreButton
                store={EStoreName.RuStore}
                data-test='store-btn'
            />
        </Container>
    );
};

export default MobileStores;
